import { useEffect, useState } from "react";
import emailjs from "emailjs-com";
import "./Packages.css";

const plans = [
  { name: "Basic Plan",    price: "2150", badge: "Entry Level",   dots: 1 },
  { name: "Standard Plan", price: "2300", badge: "Most Chosen",   dots: 2 },
  { name: "Premium Plan",  price: "2600", badge: "Premium Build", dots: 3 },
];

const topics = [
  "Scope of Work",
  "Structure",
  "Kitchen",
  "Bathroom",
  "Plumbing",
  "Doors & Windows",
  "Painting",
  "Flooring",
  "Electrical",
  "Other Inclusive Things",
];

const Packages = () => {
  const [activePlan, setActivePlan] = useState(1);
  const [showPopup, setShowPopup]   = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedTopic,   setSelectedTopic]   = useState(null);
  const [formData,    setFormData]    = useState({ name: "", email: "", mobile: "" });
  const [isSubmitting,setIsSubmitting]= useState(false);
  const [submitMessage,setSubmitMessage]= useState("");
  const [submitStatus, setSubmitStatus] = useState("");

  const openModal = (pkg, topic = null) => {
    setSelectedPackage(pkg);
    setSelectedTopic(topic);
    setShowPopup(true);
    setSubmitMessage("");
    setSubmitStatus("");
    setFormData({ name: "", email: "", mobile: "" });
  };

  const closeModal = () => {
    setShowPopup(false);
    setSelectedPackage(null);
    setSelectedTopic(null);
  };

  useEffect(() => {
    document.body.classList.toggle("popup-open", showPopup);
    return () => document.body.classList.remove("popup-open");
  }, [showPopup]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage("");
    try {
      await emailjs.send(
        "service_mc8o6ig",
        "template_nxukv4d",
        {
          from_name:     formData.name,
          from_email:    formData.email,
          mobile:        formData.mobile,
          package_name:  selectedPackage.name,
          package_price: selectedPackage.price,
          topic_name:    selectedTopic ?? "General Package Inquiry",
          reply_to:      formData.email,
          message: `Enquiry for ${selectedPackage.name} at ₹${selectedPackage.price}/sqft${
            selectedTopic ? " — " + selectedTopic : ""
          }. Name: ${formData.name}, Email: ${formData.email}, Mobile: ${formData.mobile}`,
        },
        "SVIfNeyxJHRHMt_4_"
      );
      setSubmitStatus("success");
      setSubmitMessage("Your enquiry has been received. Our team will be in touch within 24 hours.");
      setTimeout(() => closeModal(), 3000);
    } catch {
      setSubmitStatus("error");
      setSubmitMessage("Something went wrong. Please try again or call us directly.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="pkg-wrap">

      {/* ── Header ── */}
      <div className="pkg-header">
        <span className="pkg-eyebrow">Packages</span>
        <h2 className="pkg-heading">Choose the right construction package</h2>
        <p className="pkg-subhead">
          Compare package levels and request full details directly from Sarathi Constructions.
        </p>
      </div>

      {/* ── Cards ── */}
      <div className="pkg-grid">
        {plans.map((plan, idx) => (
          <article
            key={plan.name}
            className={`pkg-card${activePlan === idx ? " lead" : ""}`}
            onClick={() => setActivePlan(idx)}
          >
            <div className="lead-badge">{plan.badge}</div>

            <div className="tier-bar">
              {[0, 1, 2].map((i) => (
                <div key={i} className={`tier-dot${i < plan.dots ? " filled" : ""}`} />
              ))}
            </div>

            <p className="pkg-name">{plan.name}</p>

            <div className="pkg-price-row">
              <span className="pkg-rupee">₹</span>
              <span className="pkg-amount">{plan.price}</span>
            </div>
            <p className="pkg-unit">per sq. ft.</p>

            <div className="pkg-divider" />

            <ul className="pkg-topics">
              {topics.map((topic) => (
                <li
                  key={topic}
                  className="pkg-topic"
                  onClick={(e) => { e.stopPropagation(); openModal(plan, topic); }}
                >
                  <span className="pkg-check">✓</span>
                  <span className="topic-name">{topic}</span>
                  <span className="topic-arrow">→</span>
                </li>
              ))}
            </ul>

            <button
              type="button"
              className="pkg-cta"
              onClick={(e) => { e.stopPropagation(); openModal(plan, null); }}
            >
              Request Details
            </button>
          </article>
        ))}
      </div>

      {/* ── Modal ── */}
      {showPopup && (
        <div
          className="pkg-overlay"
          onClick={(e) => e.target.classList.contains("pkg-overlay") && closeModal()}
        >
          <div className="pkg-modal">
            <button type="button" className="modal-close" onClick={closeModal}>×</button>

            <span className="modal-eyebrow">
              {selectedTopic
                ? `${selectedPackage?.name} — ${selectedTopic}`
                : "Package Enquiry"}
            </span>

            <h3 className="modal-title">
              {selectedTopic ? selectedTopic : selectedPackage?.name}
            </h3>

            <p className="modal-subtitle">
              {selectedTopic
                ? `Request full details on the ${selectedTopic} specification within the ${selectedPackage?.name} at ₹${selectedPackage?.price}/sq.ft.`
                : `Receive the full specification sheet and a personalised quote for the ${selectedPackage?.name} at ₹${selectedPackage?.price}/sq.ft.`}
            </p>

            <div className="modal-divider" />

            {submitMessage && (
              <div className={`submit-message ${submitStatus}`}>{submitMessage}</div>
            )}

            {!submitStatus && (
              <form className="modal-form" onSubmit={handleSubmit}>
                <label className="modal-label">
                  Full Name
                  <input className="modal-input" type="text"  name="name"
                    value={formData.name}   onChange={handleInputChange}
                    required placeholder="Rajesh Kumar" />
                </label>
                <label className="modal-label">
                  Email Address
                  <input className="modal-input" type="email" name="email"
                    value={formData.email}  onChange={handleInputChange}
                    required placeholder="rajesh@example.com" />
                </label>
                <label className="modal-label">
                  Mobile Number
                  <input className="modal-input" type="tel"   name="mobile"
                    value={formData.mobile} onChange={handleInputChange}
                    required placeholder="+91 98765 43210" />
                </label>
                <button type="submit" className="modal-submit" disabled={isSubmitting}>
                  {isSubmitting ? "Sending…" : "Send Enquiry"}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Packages;